import React from "react";
import { X, Palmtree, Timer, Stethoscope } from "lucide-react";

export const TIPO_META = {
  ferie:    { label: "Ferie",    icon: Palmtree,    color: "#64748b" },
  permesso: { label: "Permesso", icon: Timer,       color: "#db2777" },
  malattia: { label: "Malattia", icon: Stethoscope, color: "#0891b2" },
};

export default function NewRequestModal({ form, setForm, lavoratori, onClose, onSubmit, saving }) {
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-md shadow-2xl w-full max-w-lg">
        <div className="flex items-center justify-between p-4 border-b border-slate-200">
          <h2 className="font-display text-xl font-bold">Nuova richiesta</h2>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-4 space-y-4">
          <div>
            <label className="text-xs font-semibold text-slate-600 block mb-1">Tipo</label>
            <div className="grid grid-cols-3 gap-2">
              {Object.entries(TIPO_META).map(([k, m]) => {
                const Icon = m.icon;
                const active = form.tipo === k;
                return (
                  <button
                    key={k}
                    type="button"
                    onClick={() => set("tipo", k)}
                    className={`flex flex-col items-center gap-1 p-2 border rounded-sm text-xs font-semibold ${
                      active ? "border-transparent text-white" : "border-slate-300 text-slate-700 hover:border-slate-500 bg-white"
                    }`}
                    style={active ? { backgroundColor: m.color } : {}}
                    data-testid={`tipo-${k}`}
                  >
                    <Icon className="w-4 h-4" />
                    {m.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div>
            <label className="text-xs font-semibold text-slate-600 block mb-1">Lavoratore</label>
            <select
              value={form.lavoratore_id}
              onChange={(e) => set("lavoratore_id", e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm bg-white"
              data-testid="richiesta-lavoratore"
            >
              <option value="">— seleziona —</option>
              {lavoratori.map((l) => (
                <option key={l.lavoratore_id} value={l.lavoratore_id}>
                  {l.nome} {l.cognome}
                </option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-semibold text-slate-600 block mb-1">Dal</label>
              <input
                type="date"
                value={form.data_inizio}
                onChange={(e) => set("data_inizio", e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-600 block mb-1">Al</label>
              <input
                type="date"
                value={form.data_fine}
                onChange={(e) => set("data_fine", e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm"
              />
            </div>
          </div>

          {form.tipo === "permesso" && (
            <div>
              <label className="text-xs font-semibold text-slate-600 block mb-1">Ore permesso</label>
              <input
                type="number"
                min={0}
                step={0.5}
                value={form.ore}
                onChange={(e) => set("ore", e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm"
              />
            </div>
          )}

          <div>
            <label className="text-xs font-semibold text-slate-600 block mb-1">Motivazione</label>
            <textarea
              rows={2}
              value={form.motivazione}
              onChange={(e) => set("motivazione", e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm"
              placeholder="Motivo della richiesta"
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 p-4 border-t border-slate-200 bg-slate-50">
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold border border-slate-300 rounded-sm hover:bg-white">Annulla</button>
          <button
            onClick={onSubmit}
            disabled={saving}
            data-testid="btn-submit-richiesta"
            className="px-4 py-2 text-sm font-semibold bg-blue-700 hover:bg-blue-800 text-white rounded-sm disabled:opacity-60"
          >
            {saving ? "Invio…" : "Invia richiesta"}
          </button>
        </div>
      </div>
    </div>
  );
}
